import { Filter, FiltersConfig } from '../../_models/filter';

export const mockFilters: Filter[] = [
    {
        id: 1,
        name: 'carrier',
        required: true,
        dataType: 'radio',
        apiSearch: 'carrier'
    },
    {
        id: 2,
        name: 'transport_unit',
        required: true,
        dataType: 'radio',
        apiSearch: 'transport_unit'
    },
    {
        id: 3,
        name: 'ship_doc',
        required: true,
        dataType: 'text',
        maxLength: 50
    },
    {
        id: 4,
        name: 'outbound_delivery',
        required: true,
        dataType: 'text',
        maxLength: 50
    },
    {
        id: 5,
        name: 'company_code',
        required: false,
        dataType: 'number',
        maxLength: 50
    }
];

export const mockConfigFilters: FiltersConfig = {
    carrier: 4,
    company_code: "3",
    date: { year: 2020, month: 8, day: 22 },
    outbound_delivery: "ed",
    ship_doc: "34",
    signed: true,
    transport_unit: 2
};